/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdfQueryResponse,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdfPathParams,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf401,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf404,
  GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf500,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf.ts";

function getGetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdfUrl(
  courseRegistrationId: GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdfPathParams["courseRegistrationId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/classroomdiscipline/grade-and-frequence/course-registrations/${courseRegistrationId}/grade-simulation/pdf` as const,
  };
  return res;
}

/**
 * @description Gera e devolve (download) o PDF com as notas e frequências do aluno a partir do Id de matrícula. Respeita as configurações da Disciplina no Módulo (o que conta e o que aparece no documento). **(Requer Authorization para autenticação)**
 * @summary Baixar PDF da simulação de notas e frequência (Requer Authorization para autenticação)
 * {@link /api/v1/classroomdiscipline/grade-and-frequence/course-registrations/:courseRegistrationId/grade-simulation/pdf}
 */
export async function getApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf(
  courseRegistrationId: GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdfPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdfQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf401
      | GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf404
      | GetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdf500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeSimulationPdfUrl(
      courseRegistrationId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
